import { SolutionTypeEnum } from "@/model/enum/SolutionTypeEnum";
import { vodarenstvo } from "./solutionsPartials/vodarenstvo";
import { obnovitelneZdroje } from "./solutionsPartials/obnovitelneZdroje";
import { priemysel } from "./solutionsPartials/priemysel";
import { fontany } from "./solutionsPartials/fontany";
import { energetika } from "./solutionsPartials/energetika";
import { servis } from "./solutionsPartials/servis";

export function useSolutionsData() {
  const solutions = [
    vodarenstvo,
    obnovitelneZdroje,
    priemysel,
    fontany,
    energetika,
    servis,
  ];

  const getSolutionByType = (type?: string) => {
    const validTypes = Object.values(SolutionTypeEnum);
    if (!type || !validTypes.includes(type as SolutionTypeEnum)) {
      return null;
    }
    return solutions.find((solution) => solution.type === type);
  };

  return { getSolutionByType, solutions };
}
